import { useState } from "react";
import CommonMessage from "../../common/CommonMessage";

const ChangePWD = () => {
    const INITIAL_VALUES = {
        cPassword: "",
        newPassword: "",
        cnfPassword: "",
    };

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [formData, setFormData] = useState(INITIAL_VALUES);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const validateForm = () => {
        let newErrors = {};

        if (!formData.cPassword.trim()) {
            newErrors.cPassword = "Current password is required";
        }

        if (!formData.newPassword.trim()) {
            newErrors.newPassword = "New password is required";
        } else if (formData.newPassword.length < 6) {
            newErrors.newPassword =
                "Password must be at least 6 characters";
        }

        if (!formData.cnfPassword.trim()) {
            newErrors.cnfPassword = "Confirm password is required";
        } else if (formData.newPassword !== formData.cnfPassword) {
            newErrors.cnfPassword = "Passwords do not match";
        }

        if (
            formData.cPassword &&
            formData.newPassword &&
            formData.cPassword === formData.newPassword
        ) {
            newErrors.newPassword =
                "New password must be different from current password";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        if (!validateForm()) {
            return;
        }

        try {
            setLoading(true);

            const payload = {
                cpwd: formData.cPassword,
                newpwd: formData.newPassword,
            };

            console.log("Payload:", payload);

            // const response = await changePassword(payload);

            // if (response?.statusCode === 200) {
            //     setMessage("Password changed successfully");
            //     setFormData(INITIAL_VALUES);
            //     setErrors({});
            // } else {
            //     setMessage("Failed to change password");
            // }

            // Demo Success
            setMessage("Password changed successfully");
            setFormData(INITIAL_VALUES);
            setErrors({});
        } catch (error) {
            console.error(error);
            setMessage("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">Change Password</h4>
                </div>

                <div className="card-body">
                    {message && <CommonMessage text={message} />}

                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            {/* Current Password */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    Current Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    name="cPassword"
                                    value={formData.cPassword}
                                    onChange={handleChange}
                                />
                                {errors.cPassword && (
                                    <small className="text-danger">
                                        {errors.cPassword}
                                    </small>
                                )}
                            </div>

                            {/* New Password */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    New Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    name="newPassword"
                                    value={formData.newPassword}
                                    onChange={handleChange}
                                />
                                {errors.newPassword && (
                                    <small className="text-danger">
                                        {errors.newPassword}
                                    </small>
                                )}
                            </div>

                            {/* Confirm Password */}
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    Confirm Password
                                </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    name="cnfPassword"
                                    value={formData.cnfPassword}
                                    onChange={handleChange}
                                />
                                {errors.cnfPassword && (
                                    <small className="text-danger">
                                        {errors.cnfPassword}
                                    </small>
                                )}
                            </div>

                            {/* Submit Button */}
                
                            <div className="col-md-12">
                                <button
                                    type="submit"
                                    className="btn btn-success"
                                    disabled={loading}
                                >
                                    {loading
                                        ? "Submitting..."
                                        : "Change Password"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ChangePWD;